import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  icon: '😰',
  text: 'Historias clínicas sin estructura profesional',
  color: 'border-l-red-500'
}, {
  icon: '⚖️',
  text: 'Sin cobertura legal ante situaciones de riesgo',
  color: 'border-l-amber-500'
}, {
  icon: '⏰',
  text: 'Horas perdidas armando documentación desde cero',
  color: 'border-l-blue-500'
}, {
  icon: '😓',
  text: 'Inseguridad ante urgencias o crisis sin protocolo',
  color: 'border-l-purple-500'
}, {
  icon: '💊',
  text: 'Polifarmacia compleja sin sistema de seguimiento',
  color: 'border-l-emerald-500'
}, {
  icon: '📄',
  text: 'Informes forenses o legales mal estructurados',
  color: 'border-l-orange-500'
}, {
  icon: '🔥',
  text: 'Burnout sin herramientas de protección',
  color: 'border-l-rose-500'
}, {
  icon: '💸',
  text: 'Pacientes morosos sin saber cómo abordarlo',
  color: 'border-l-yellow-500'
}];
export function PainPointsSection() {
  return <section className="py-12 md:py-16 bg-navy relative overflow-hidden" data-id="element-89">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-90"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-10" data-id="element-92">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-2" data-id="element-93">
            Esto es para vos si...
          </h2>
          <p className="text-sm md:text-base text-gray-400" data-id="element-94">
            ¿Te sentís identificado con alguna de estas situaciones?
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4" data-id="element-95">
          {painPoints.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className={`flex items-center gap-3 bg-navy-light/60 border border-navy-lighter border-l-[3px] ${item.color} rounded-lg px-4 py-3 hover:bg-navy-light/80 hover:border-gold/20 transition-colors`} data-id="element-96">
              <span className="text-xl shrink-0" data-id="element-97">{item.icon}</span>
              <span className="text-sm md:text-base text-gray-200 font-medium" data-id="element-98">
                {item.text}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 md:mt-8 text-center" data-id="element-99">
          <p className="inline-block text-gold font-semibold text-sm md:text-base bg-gold/5 border border-gold/20 rounded-full px-5 py-2" data-id="element-100">
            ✅ Si te identificás con al menos una, el Sistema PRO fue diseñado
            para vos.
          </p>
        </motion.div>
      </div>
    </section>;
}